import React, { useState, useEffect } from 'react';
import { Animated } from 'react-native';

export const HideOnScroll = ({ children, style }) => {
  const [scrollY] = useState(new Animated.Value(0));
  const [isVisible, setIsVisible] = useState(true);
  const [isHovering, setIsHovering] = useState(false);
  let lastScrollY = 0;
  let ticking = false;

  useEffect(() => {
    if (typeof window !== 'undefined') {
      const handleScroll = () => {
        if (!ticking) {
          window.requestAnimationFrame(() => {
            const currentScrollY = window.scrollY;
            
            // Show header if user is near the top of the page
            if (currentScrollY < 50) {
              setIsVisible(true);
            } else {
              // Show header if scrolling up, hide if scrolling down
              setIsVisible(currentScrollY < lastScrollY || isHovering);
            }
            
            lastScrollY = currentScrollY;
            ticking = false;
          });
          
          ticking = true;
        }
      };

      window.addEventListener('scroll', handleScroll, { passive: true });
      return () => window.removeEventListener('scroll', handleScroll);
    }
  }, [isHovering]);

  const translateY = scrollY.interpolate({
    inputRange: [0, 100],
    outputRange: [0, -100],
    extrapolate: 'clamp',
  });

  return (
    <Animated.View
      style={[
        style,
        {
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          zIndex: 1000,
          transform: [{ translateY: isVisible ? 0 : -100 }],
          transition: 'transform 0.3s ease',
        },
      ]}
      onMouseEnter={() => setIsHovering(true)}
      onMouseLeave={() => setIsHovering(false)}
    >
      {children}
    </Animated.View>
  );
}; 